// react library imports
import { Suspense } from 'react'; 
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider, Helmet  } from 'react-helmet-async';

// style imports
import './App.css';
import './style/global.css';
import './style/mixins.css';
import './style/popup.css';
import './style/variables.css';
import './style/typography.css';

// import from main component
import { LoadingScreen } from 'Component';
// import PreProduction from './PreProduction';

// imports from routes
import { router } from './Routes/routes';

const App = () => {
  const websiteDescription = "Empowering educators and transforming learning experiences with innovative technology solutions.";
  return(
    <HelmetProvider>
      <Helmet>
        <title>mues.tech</title>
        <meta name="description" content={websiteDescription} />
        <meta property="og:title" content="mues.tech" />
        <meta property="og:description" content={websiteDescription} />
        <meta property="og:url" content="https://mues.tech" />
      </Helmet>
      <Suspense fallback={<LoadingScreen/>}>
        <RouterProvider router={router} />
        {/* <PreProduction/> */}
      </Suspense>
    </HelmetProvider>
  ) 
}

export default App;